import { DateField } from "react-admin";
import type { DateFieldProps } from "ra-ui-materialui";
import useDefaultLocale from "../../../common/util/useDefaultLocale";

const ProLogsDateField = (props: DateFieldProps) => {
  const defaultLocale = useDefaultLocale();
  return <DateField {...props} locales={props.locales ?? defaultLocale} />;
};

export default ProLogsDateField;
